export enum ProviderName {
  google = 'google',
  yandex = 'yandex',
  leaflet = 'leaflet',
  baidu = 'baidu',
  mapbox = 'mapbox',
  horse = 'horse',
}
